var map = {
	"./2000px-Tatort_Logo.png": 2143,
	"./Backdrop_Circle.png": 2939,
	"./Person_TRI2_smallSize.jpg": 216,
	"./RS_Banner.png": 9548,
	"./background_final_small.jpg": 8077,
	"./dialog_finished.jpg": 8187,
	"./female.jpg": 8704,
	"./logo_beside_white_font.png": 4884,
	"./male.png": 2383,
	"./welcome.jpg": 4482
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9555;